import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { sizeMap, defaultSize } from '../../buttons/NodeSizeButton/consts.js';
import DropdownModal from './DropdownModal.js';
import ListItemSelect from '../ListItem/ListItemSelect.js';
import '../../icons/SizeContentIcon.js';
import '../../icons/SizeSmallIcon.js';
import '../../icons/SizeOriginalIcon.js';
import '../../icons/SizeFullWidthIcon.js';
import 'wix-rich-content-ui-components';
import '../../style-inject.es-746bb8ed.js';
import 'classnames';
import 'wix-rich-content-common/libs/Tooltip';

const SizePanel = ({ getSelectedSize, onClick, options }) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};
  const OPTIONS = options ? options.map((option) => sizeMap[option]) : defaultSize;
  const onKeyDown = (e, commandKey) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick(commandKey);
      e.stopPropagation();
    }
  };
  const DropdownOptions = OPTIONS.map(({ dataHook, icon: Icon, text, commandKey, tooltip }) => /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      key: commandKey,
      dataHook,
      prefix: /* @__PURE__ */ React.createElement(Icon, null),
      title: t(text),
      selected: commandKey === getSelectedSize(),
      onKeyDown: (e) => {
        onKeyDown(e, commandKey);
      },
      tooltip: t(tooltip),
      onClick: () => onClick(commandKey)
    }
  ));
  return /* @__PURE__ */ React.createElement(DropdownModal, { options: DropdownOptions, jsdomMode });
};

export { SizePanel as default };
//# sourceMappingURL=SizePanel.js.map
